// import request from '@/router/axios'
import {request} from '@/network/request'

export function fetchList(query) {
  return request({
    url: '/gaoligong/helpproblem/page',
    method: 'get',
    params: query,
  })
}
export function addObj(obj) {
  return request({
    url: '/gaoligong/helpproblem',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/helpproblem/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/helpproblem/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/helpproblem',
    method: 'put',
    data: obj
  })
}
